module.exports = "/images/ir.svg?2ebc7cf18763d260252f01e1de93c49e";